<template>
  <div class="container">
    <div>
      <h4 class="text-center" style="margin-bottom: 2rem">
        {{ $t('instagram.warning') }}
      </h4>
      <div class="deepgram-input">
        <b-form-input
          v-model="queryParam"
          style="margin-bottom: 2rem"
          :placeholder="$t('instagram.placeholder')"
        />
        <span>
          <b-spinner v-if="loading" small label="Spinning"></b-spinner>
        </span>
      </div>
    </div>
    <div>
      <div v-if="users && users.length === 0">
        <b-alert show variant="danger"
          >Bu kullanıcı adına ait bi hesap bulunamadı.</b-alert
        >
      </div>
      <b-row :class="{ loading }" style="transition: 200ms">
        <b-col
          xxs="6"
          xs="6"
          sm="6"
          md="4"
          lg="3"
          v-for="(user, index) in users"
          :key="index"
        >
          <div class="deepgram-insta-card">
            <img
              :src="'data:image/jpeg;base64,' + user.profile_pic_url"
              alt=""
            />
            <h1>{{ user.full_name || '_' }}</h1>
            <h2>{{ user.username }}</h2>
            <button @click="handleClick(user)">This is me</button>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { debounce } from 'debounce';
import { API } from '@/services/';
import { API_BASE_URL, API_INSTAGRAM_SAVE } from '../helpers/config';
/* eslint-disable */
export default {
  data: () => ({
    users: null,
    queryParam: '',
    debouncedText: '',
    loading: false,
  }),
  watch: {
    queryParam: function (val) {
      this.debouncer();
    },
    debouncedText: async function (val) {
      this.loading = true;
      const res = await API.get(
        API_BASE_URL + '/instagram/username/' + this.debouncedText
      );
      this.users = res.data.users;
      this.loading = false;
    },
  },
  methods: {
    handleClick: function (user) {
      API.post(API_INSTAGRAM_SAVE, {
        uuid: this.$route.query.userId,
        instaId: user.pk,
        username: user.username,
        fullName: user.full_name,
        profilePicUrl: user.profile_pic_url,
        isPrivate: user.is_private,
        isVerified: user.is_verified,
      }).then((response) => {
        this.$router.push('/test/' + this.$route.query.testId + '/result');
      });
    },
    debouncer: debounce(function () {
      this.debouncedText = this.queryParam;
    }, 500),
  },
};
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Nunito:100,100italic,200,200italic,300,300italic,regular,italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic);
h1 {
  font-size: 90%;
  font-weight: bold;
}
.loading {
  opacity: 0.5;
  pointer-events: none;
}
.deepgram-input {
  position: relative;
}
.deepgram-input > span {
  position: absolute;
  right: 16px;

  top: 50%;
  transform: translateY(-50%);
}

.deepgram-insta-card {
  font-family: Nunito;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12px;
  border: 1px solid rgb(214, 214, 214);
  padding: 26px;
  background: white;
  border-radius: 8px;
  transition: 200ms;
}
.deepgram-insta-card:hover {
  transform: scale(1.02);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.07);
}
.deepgram-insta-card > img {
  border-radius: 50%;
  width: 100%;
  max-width: 150px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}
.deepgram-insta-card h1 {
  margin-top: 8px;
  font-weight: 600;
  font-size: 18px;
}
.deepgram-insta-card h2 {
  font-size: 14px;
}
.deepgram-insta-card button {
  background: none;
  border: 0;
  background: rgb(0, 140, 255);
  color: white;
  border-radius: 12312312px;
  padding: 4px 12px;
  font-size: 14px;
  margin-top: 8px;
}
</style>